import { Map } from 'immutable';
import {
  FETCH_ONLINE_USAGE_SUCCESS,
} from './actions';
import OnlineUsage from './model';

export default function onlineUsagesReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_ONLINE_USAGE_SUCCESS:
      return state.set(action.groupId, getOnlineUsage(state, action));
    default:
      return state;
  }
}

function getOnlineUsage(state, action) {
  let OnlineUsages = new Map({});
  action.payload.forEach((onlineUsages) => {
    OnlineUsages = OnlineUsages.set(`${onlineUsages.studentId}`, OnlineUsage.create(onlineUsages));
  });
  return OnlineUsages;
}



// WEBPACK FOOTER //
// ./data/OnlineUsage/reducer.js